import React, { useEffect, useState } from "react";
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { DeveloperState } from "@/const";

export default function DeveloperStateDisplay({ developer }) {
    const { t } = useTranslation();

    const [badgeVariant, setBadgeVariant] = useState("secondary");
    const [badgeText, setBadgeText] = useState("");

    useEffect(() => {
        if (developer.state === DeveloperState.NEW) {
            setBadgeVariant("primary");
            setBadgeText(t("Новый"));
        }
        if (developer.state === DeveloperState.APPROVED) {
            setBadgeVariant("success");
            setBadgeText(t("Одобрен"));
        }
        if (developer.state === DeveloperState.REJECTED) {
            setBadgeVariant("danger");
            setBadgeText(t("Отклонен"));
        }
    }, [developer]);

    if (!developer) {
        return null;
    }

    if (developer.state === DeveloperState.NEW) {
        return <Badge variant={badgeVariant}>{badgeText}</Badge>;
    }

    return (
        <OverlayTrigger
            overlay={(props) => (
                <Tooltip {...props}>
                    <div>
                        {t("Когда")}: {developer.date_state}
                    </div>
                </Tooltip>
            )}
            placement="bottom"
        >
            <Badge variant={badgeVariant}>{badgeText}</Badge>
        </OverlayTrigger>
    );
}
